// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3LMUD","modalFooterButton":"ModalNotes_modalFooterButton__B33_T"};